import hyperdom from 'hyperdom'
import differenceInMinutes from 'date-fns/difference_in_minutes'
import durationText from '../../../../packages/dates/durationText.js'
import assetPath from '../assetPath.js'
import baggageNotes from './baggageNotes.jsx'
import datesNotes from '../flights/datesNotes.jsx'
import * as gtmDataLayer from '../analytics/gtm/dataLayer.js'
import airportTimezone from '../../../../packages/dates/airportTimezone.js'
import {Message, MessageTypes} from '../message.jsx'

export default class {
  constructor (model){
    this.model = model
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  partyText (){
    const model = this.model
    const party = model.party()
    const adultSuffix = party.adults === 1 ? 'adult' : 'adults'
    let adults = party.adults + ' ' + adultSuffix
    let children = ''
    if (party.children) {
      var suffix = party.children === 1 ? 'child' : 'children'
      children = ' and ' + party.children + ' ' + suffix
    }

    return adults + children
  }

  pricePerPerson (total) {
    var party = this.model.party()
    return total / (party.adults + party.children)
  }

  renderTrip (trip, showBuyButton) {
    var model = this.model

    function airport (code){
      return model.airports.filter(airport => airport.code === code)[0].name
    }

    function stopsText (stops){
      if (stops.length > 1) {
        return stops.length + ' stops'
      }
      if(stops.length === 0){
        return 'Non-stop'
      }
      return stops.length + ' stop'
    }

    function renderLegDescription (leg){
      return <span>{leg.airline.code}{leg.flight} - {leg.airline.name} <span class="flights-details__cabin">({leg.cabin})</span></span>
    }

    function renderOperatingAirlines (leg) {
      var operatingFlights = leg.flights.filter(function (flight){ return flight.operatingAirline && flight.operatingAirline.name !== flight.airline.name })
      return operatingFlights.map(function (flight){
        return <div class="operating-airline">{flight.airline.code}{flight.flight} operated by {flight.operatingAirline.name}</div>
      })
    }

    function legDuration (leg){
      const totalMinutes = leg.lastFlight.arriveDate.diff(leg.firstFlight.departDate, 'minutes')
      return durationText(Math.abs(totalMinutes))
    }

    function flightDuration (flight){
      var totalMinutes = differenceInMinutes(
        flight.arriveDate.toDate(),
        flight.departDate.toDate()
      )
      return durationText(Math.abs(totalMinutes))
    }

    function addFlight (trip) {
      var flights = model.flights
      flights.id = trip.id
      flights.searchMode = 'selected'
      flights.clearWarnings()
      return flights.select(trip)
    }

    function toggleDetails (ev, leg) {
      ev.preventDefault()
      leg.showDetails = !leg.showDetails
    }

    function setDefaultImage () {
      this.onerror = ""
      this.src = assetPath("/public/img/airline_logo/nologo.png")
      return true
    }

    function renderAirFareRules (response) {
      const renderAirFareContent = () => {
        if (response.status !== 'successful' || !response.rules || response.rules.length === 0) {
          return <div class='modal-airfare-rules__container'>
            <h1 class='modal-airfare-rules__content'>Airfare Rules apply, please refer to the Airfare Rules attachment sent with the invoice</h1>
            <button class='btn btn-primary' onclick={() => model.modals.close()}>Accept and continue</button>
          </div>
        }

        return <div class='modal-airfare-rules__container'>
          {response.rules.map(rule => {
            return hyperdom.rawHtml('p.modal-airfare-rules__content', rule.desc)
          })}
        </div>
      }

      return <div class='modal-airfare-rulse'>
        <div class='modal-airfare-rules__header'>
          <h1 class='modal-airfare-rules__header--title'>Airfare rules</h1>
          <div class='modal-airfare-rules__header--close' onclick={() => model.modals.close()}></div>
        </div>
        {renderAirFareContent()}
      </div>
    }

    function showAirfareRules (trip) {
      const getAirfareRules = async () => {
        model.showLoading()
        return model.api.getAirFareRules({
          sellingCompanyCode: model.config.sellingCompanyCode,
          fares: trip.fares,
          itinerary: trip.itinerary,
          tokenId: trip.tokenId,
        }).then(response => {
          model.hideLoading()
          model.modals.show({
            render: () => renderAirFareRules(response),
            dataTest: 'airfare-rules',
            classNames: 'o-centered-airfare-rules',
          })
        })
      }

      if (model.config.showAirfareRules) {
        return <div class="airfare-rules">
          <div class="flights-search-results__airfare-rule" onclick={() => getAirfareRules()}>View Airfare Rules</div>
        </div>
      }
    }


    function renderLeg (leg) {
      const renderLogo = className => (
        <img className={className}
          onerror={setDefaultImage}
          src={assetPath(`/public/img/airline_logo/${leg.firstFlight.airline.code.toLowerCase()}.png`)}
        />
      )
      return (
        <div class="flight-leg">
          <div class="flight-leg__header">
            {renderLogo('flight-leg__header-logo')}
            <div className="flight-leg__header-airline">
              {leg.firstFlight.airline.name} {' - '} <span className="cabin">{leg.isMixedCabin ? 'Mixed Cabin' : leg.firstFlight.cabin}</span>
            </div>
          </div>
          <div class="flight-leg__body">
            <div class="flight-leg__body-info">
              <div class="flight-leg__date-container">
                {renderLogo('flight-leg__logo')}
                <div class="flight-leg__depart-container">
                  <div class="flight-leg__depart-date">
                    {leg.firstFlight.departDate.tz(airportTimezone(leg.firstFlight.depart)).format('DD MMM')}
                  </div>
                  <div class="flight-leg__depart-time">
                    {leg.firstFlight.departDate.tz(airportTimezone(leg.firstFlight.depart)).format('HH:mm')}
                  </div>
                </div>
                <div class="flight-leg__date-divider">-</div>
                <div class="flight-leg__arrive-container">
                  <div class="flight-leg__arrive-date">
                    {leg.lastFlight.arriveDate.tz(airportTimezone(leg.lastFlight.arrive)).format('DD MMM')}
                  </div>
                  <div class="flight-leg__arrive-time">
                    {leg.lastFlight.arriveDate.tz(airportTimezone(leg.lastFlight.arrive)).format('HH:mm')}
                  </div>
                </div>
              </div>
              <div class="flight-leg__duration-container">
                <div class="flight-leg__duration-airports">
                  {leg.firstFlight.depart + ' - ' + leg.lastFlight.arrive}
                </div>
                <div class="flight-leg__duration">{legDuration(leg)}</div>
              </div>
              <div class="flight-leg__stops-container">
                <div class="flight-leg__stops-amount">{stopsText(leg.stops)}</div>
                <div class="flight-leg__stops-airports">{leg.stops.join(', ') || '–'}</div>
              </div>
            </div>
          </div>
          {renderOperatingAirlines(leg)}
        </div>
      )
    }

    return ([<div class="flights-search-results__summary">
      {trip.legs.map(renderLeg)}
    </div>,
    <div className='flights-search-results__bottom-panel'>
      <div className="flights-search-results__buy">
        <div class='flights-search-results__actions'>
          <a className="toggle-flights-details" onclick={ev => toggleDetails(ev, trip)}>Flight details</a>
          {showAirfareRules(trip)}
        </div>
        <div className="flights-search-results__buy__price-row">
          {this.renderPrice(trip)}
          {showBuyButton
            ? <button
                  type="button"
                  class="btn-secondary flights-search-results__cta"
                  onclick={() => addFlight(trip)}
                  data-item-name='add-this-flight-cta'
                  data-item-type='General Interaction'
              >Add this flight</button>
            : <div className="btn-secondary-green flights-search-results__cta">Added</div>}
        </div>
      </div>
    </div>,
    <div className={["flight-details",{'show-expanded': trip.showDetails}]}>
      {trip.legs.map(function (leg) {
        return <div class="flights-details__bound">
          {leg.flights.map(function (flight, index) {
            var legMarkup = [
              <div class={['flights-details__leg', 'leg-' + (index + 1)]}>
                <div class="flights-details__info">
                  <h5 class="flights-details__identifier">
                    <img class="flights-details__mini-airline-logo" onerror={ setDefaultImage } src={ assetPath(
                      "/public/img/airline_logo/" + flight.airline.code.toLowerCase() + ".png"
                    ) } />
                    {renderLegDescription(flight)}
                  </h5>
                  {
                    flight.operatingAirline
                      ? <p class="flights-details__secondary-info flights-details__operated-by">operated by {
                        flight.operatingAirline.name}</p>
                      : undefined
                  }
                  {
                    // <p class="flights-details__secondary-info flights-details__legal">other legal info</p>
                  }
                  <p class="flights-details__secondary-info flights-details__length">{flightDuration(flight)}</p>
                </div>

                <div class="flights-details__schedule">
                  <img class="flights-details__airline-logo" onerror={ setDefaultImage } src={ assetPath(
                    "/public/img/airline_logo/" + flight.airline.code.toLowerCase() + ".png"
                  ) } />

                  <div class="flights-details__place-and-time">
                    <div class="flights-details__date">{flight.departDate.tz(airportTimezone(flight.depart)).format('DD MMM YYYY')}</div>
                    <div class="flights-details__time">{flight.departDate.tz(airportTimezone(flight.depart)).format('HH:mm')}</div>
                    <div class="flights-details__airport">
                      <strong>{flight.depart}</strong> {airport(flight.depart)}
                    </div>
                  </div>

                  <div class="flights-details__place-and-time">
                    <div class="flights-details__date">{flight.arriveDate.tz(airportTimezone(flight.arrive)).format('DD MMM YYYY')}</div>
                    <div class="flights-details__time">{flight.arriveDate.tz(airportTimezone(flight.arrive)).format('HH:mm')}</div>
                    <div class="flights-details__airport">
                      <strong>{flight.arrive}</strong> {airport(flight.arrive)}
                    </div>
                  </div>
                </div>
              </div>,
            ]
            if (leg.flights.length > index + 1) {
              legMarkup.push(<div class="flights-details__connection">Connection</div>)
            }
            return legMarkup
          })}
        </div>
      })}

    </div>])
  }

  notAvailable (){
    var flights = this.model.flights
    return <div class="flights-search-results options">
      <button type="button"
        className="btn-secondary-outline flights-search-results__change-search u-margin-bottom-medium"
        onclick={() => this.showCriteria()}
        data-item-type='General Interaction'
        data-item-name='change-search-flights-cta'
      >
        Change search
      </button>
      {new Message({
        className: 'not-available',
        header: 'Not available',
        message: 'We are sorry but we are unable to take flight bookings online at this time.',
        type: MessageTypes.WARNING,
      })}
      <div class="callback">
        <p>However, one of our experts can give you a call to arrange flights to help connect you with this trip. Would you like to be contacted after you complete your booking?</p>
        <label htmlFor={`flights-callback`} className='o-choice-item -fullWidth u-margin-bottom-none'>
          <input id={'flights-callback'} type='checkbox'
            className='o-choice-item__checkbox o-choice-item__checkbox-small'
            binding={[flights, 'callback']}/>
          <div className='o-choice-item__content o-choice-item__content_small'>
            <span>Yes, I would like to be contacted</span>
          </div>
        </label>
      </div>

      {this.callbackNotes()}
    </div>
  }

  callbackNotes () {
    var flights = this.model.flights
    if (flights.callback && this.model.sellingCompanyCode === 'TTUKLS') {
      return <div class="callback-notes">
        <p><strong>Note: </strong>Your requested flight dates will be sent to our reservations department to be quoted. You will then be contacted with the flight and airfare details by a reservation agent within 2 Business Days.</p>
      </div>
    }
  }

  noResults () {
    var flights = this.model.flights
    return <div className="flights-search-results options">
      <button type="button"
        className="btn-secondary-outline flights-search-results__change-search u-margin-bottom-medium"
        onclick={() => this.showCriteria()}
      >
        Change search
      </button>
      {new Message({
        className: 'no-results',
        header: 'No results',
        message: 'We are sorry but we are unable to offer flights online at this time that match your criteria.',
        type: MessageTypes.WARNING,
      })}
      <div className="callback">
        <p>However, one of our experts can give you a call to arrange flights to help connect you with this trip. Would
          you like to be contacted after you complete your booking?</p>
        <label htmlFor={`flights-callback`} className='o-choice-item -fullWidth u-margin-bottom-none'>
          <input id={`flights-callback`} type='checkbox'
            className='o-choice-item__checkbox o-choice-item__checkbox-small'
            binding={[flights, 'callback']}/>
          <div className='o-choice-item__content o-choice-item__content_small'>
            <span>Yes, I would like to be contacted</span>
          </div>
        </label>
      </div>
      {this.callbackNotes()}
    </div>
  }

  showCriteria (){
    var flights = this.model.flights
    flights.callback = true
    flights.searchMode = 'criteria'
    return false
  }

  removeFlight (){
    var model = this.model
    var flights = model.flights

    delete flights.id
    flights.searchMode = 'criteria'
    flights.remove()
    this.model.quoteCriteria.removeAirPromotions()
  }

  selected (){
    var self = this
    var model = this.model
    var trip = model.selected

    function renderSelectedPrice (){
      if (model.config.flights.pricing !== 'bundled') {
        return <strong class="flights-search-results__price">{model.formatPrice(trip.total)}</strong>
      }
    }

    function removeFlight (ev) {
      ev.preventDefault()
      return self.removeFlight()
    }

    return <div class="-is-selected">
      <div class="flights-search-header">
        <div className="flights-search-selected">
          <div className='flights-search-selected__text'>
            <h4>Flights added with your trip</h4>
            <p className="flights-search-selected__party-detail">
              <div className="party">for {this.partyText()}</div>
              {renderSelectedPrice()}
            </p>
          </div>
          <button
            id="remove-selected-flights"
            className="btn-secondary-outline"
            data-item-type='General Interaction'
            data-item-name='remove-flight-cta'
            onclick={removeFlight} href="#">
            Remove flights
          </button>
        </div>
      </div>
      <div class="flights-search-results__item flights__search-white-container">
        {this.renderTrip(trip, false)}
      </div>
    </div>
  }

  renderPrice (trip) {
    const model = this.model
    if (model.config.flights.pricing === 'bundled') {
      const priceBreakdown = model.quoteCriteria.priceBreakdown()

      const priceExcludingFlights = priceBreakdown.totalWithoutFlights
        ? priceBreakdown.totalWithoutFlights
        : priceBreakdown.total
      const priceIncludingFlights = priceExcludingFlights + trip.total

      return <div class="flights-search-results__price">
        <div class="flights-search-results__price__including-flights">
          {model.formatPrice(priceIncludingFlights)} Total
        </div>
        <div class="flights-search-results__price__excluding-flights">
          {model.formatPrice(priceExcludingFlights)} Trip Price
        </div>
      </div>
    }

    return <div class="flights-search-results__price">
      <div class="flights-search-results__price__per-person">
        {this.model.formatPrice(this.pricePerPerson(trip.total))} / person
      </div>
      <div class="flights-search-results__price__total">
        {this.model.formatPrice(trip.total)}
      </div>
    </div>
  }

  flightSequence (trip){
    return <div class="flights-search-results__item flights__search-white-container">
      {this.renderTrip(trip, true)}
    </div>
  }

  renderBundlingMessage () {
    if (this.model.config.flights.pricing === 'bundled') {
      return <div class="flights-search-results__bundled-pricing-message">
        Airfares are included in the Total price shown
      </div>
    }
  }

  renderResultsWarning () {
    if (this.model.config.flights.biasWarning && this.model.exploreFlights.airline === 'any') {
      return <div className='message-info flights-search-results__bias-warning'>
        <p>
          Airfares are included in the Total price shown.
        </p>
        <p>
          {this.model.config.flights.biasWarning}
        </p>
      </div>
    }
  }

  renderBaggageInformation () {
    if (this.model.config.showBaggageNotes) {
      return <div class="flights__baggage-notes message-info">
        <h2 class="u-margin-bottom-none">Baggage information</h2>
        {baggageNotes(this.model)}
      </div>
    }
  }

  render (){
    const model = this.model
    const flights = model.flights
    const limitedFlights = Array.isArray(flights.searchResults) ? flights.searchResults.slice(0, 20) : []
    flights.criteria = !flights.criteria ?  this.returnCriteria : flights.criteria

    return <div class="flights-search-results">
      <div class="flights-search-header">
        <button type="button"
          className="btn-secondary-outline flights-search-results__change-search u-margin-bottom-medium"
          onclick={() => this.showCriteria()}
          data-item-type='General Interaction'
          data-item-name='change-search-flights-cta'
        >
          Change search
        </button>
      </div>
      {datesNotes(model)}
      {this.renderBaggageInformation()}
      {this.renderBundlingMessage()}
      {this.renderResultsWarning()}
      <div class="flights-search-results__sequences">
        {limitedFlights.map(this.flightSequence.bind(this))}
      </div>
    </div>
  }
}
